export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./galaxsys.vue?vue&type=template&id=64609379&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/galaxsys.vue?vue&type=template&id=64609379&scoped=true
// module id = 2WRQ
// module chunks = 0